<template>
    <div class="position-relative">
        <v-app class="p-4">
            <div class="">
                <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn text class="float-left mt-5" small @click="reloadTable(tableProps)" v-bind="attrs"
                               v-on="on"><span class="material-icons">refresh</span></v-btn>
                    </template>
                    <span>به روز رسانی</span>
                </v-tooltip>
                <template>
                    <v-row justify="center">
                        <v-dialog
                                v-model="BankModal"
                                max-width="900"
                                hide-overlay
                                transition="dialog-bottom-transition">
                            <v-card>
                                <v-toolbar dark color="primary">
                                    <v-toolbar-title>ایجاد دسته</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn icon dark @click="BankModal = false">
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <div>
                                    <edit-pack v-if="BankModal" :modal="()=>{this.BankModal = false}"
                                               :infos="infos"></edit-pack>
                                </div>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>
                <v-card :loading="loading" class="p-3 pt-0 mt-40">

                    <terminal-table class="col-12" :currentPage="datas.current_page"
                                    :perPage="datas.per_page" v-if="isMobile" :getData="getTableData"
                                    :pageCount="datas.last_page"
                                    :options="tableProps" :datas="datas" :headers="columns"></terminal-table>

                    <data-table
                            v-else
                            :data="datas"
                            :columns="columns"
                            :debounce-delay="3000"
                            :translate="translate"
                            :pagination="paginate"
                            :orderBy="tableProps.column"
                            :orderDir="tableProps.dir"
                            :per-page="[10, 25, 50, 100, 500]"
                            @on-table-props-changed="reloadTable"
                            class="pt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
                    ></data-table>
                </v-card>
            </div>
        </v-app>
    </div>
</template>

<script>
import TitleRibbon from "../uiBeautifier/titleRibbon";
import {Axios2, Bus, dataTableProps} from "../../../main";
import {debounce} from "../../../custom";
import button from "../button";
import EditPack from "./editPack";

export default {
    name: "BankList",
    components: {EditPack, TitleRibbon},
    data() {
        return {
            tableProps: dataTableProps.tableProps,
            translate: dataTableProps.translate,
            loading: false,
            paginate: dataTableProps.pagination,
            datas: null,
            BankModal: null,
            infos: null,
            columns: [
                {
                    label: 'شناسه',
                    name: 'id',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'دسته‌بندی',
                    name: 'category',
                    primary:true,
                },
                {
                    label: 'استان',
                    name: 'province',
                },
                {
                    label: 'شهر',
                    name: 'city',
                },
                {
                    label: 'عنوان',
                    name: 'title',
                },
                {
                    label: 'تاریخ ایجاد',
                    name: 'updated_at_p',
                },
                {
                    label: 'مدیریت',
                    name: 'action',
                    component: button,
                    handler: this.actions,
                    event: "actions",
                    meta: {
                        buttons: [
                            {
                                name: 'delete',
                                label: 'حذف بانک',
                                icon: 'trash-alt',
                                class: 'btn-outline-danger',
                                action: this.actions,
                                status: 'divar_delete',
                            },
                            {
                                name: 'edit',
                                label: 'ویرایش بانک',
                                icon: 'pencil-alt',
                                class: 'btn-outline-warning',
                                action: this.actions,
                                status: 'divar_update',
                            }
                        ]
                    }
                }
            ],
        }
    },
    methods: {
        getTableData(url = this.url, query = this.tableProps) {
            this.loading = true
            Axios2.get("/admin/archive", {
                params: query
            }).then((res) => {
                this.datas = res.data.data;
                this.loading = false
            })
        },
        reloadTable(tableProps) {
            debounce(() => {
                this.tableProps.page = this.datas.current_page;
                this.getTableData(this.url, tableProps);
            }, 1000);
        },
        actions(data, type) {
            this[type + "Action"](data);
        },
        deleteAction(data) {
            this.$modal.yesNo('تاییدیه حذف!', 'آیا از حذف این بانک اطلاعاتی اطمینان دارید؟', 'neg').then((response) => {
                if (response)
                    Axios2.delete(`admin/archive/${data.id}`).then((res) => {
                        this.$nextTick(() => {
                            this.$modal.success("موفقیت!", res.data.message);
                            this.reloadTable(this.url)
                        });
                    });
            })
        },
        editAction(data) {
            Axios2.get(`admin/archive/${data.id}`).then((res) => {
                this.$nextTick(() => {
                    this.infos = res.data.data;
                    this.BankModal = true;
                });
            });
        }
    },
    created() {
        this.getTableData();

        Bus.$on("reload", () => {
            this.reloadTable(this.tableProps);
        })
    },
    computed: {
        isMobile() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    this.getTableData(this.url);
                    return true
                case 'sm':
                    this.getTableData(this.url);
                    return true
                case 'md':
                    this.getTableData(this.url);
                    return false
                case 'lg':
                    this.getTableData(this.url);
                    return false
                case 'xl':
                    this.getTableData(this.url);
                    return false
            }
        },
    },
}
</script>

<style scoped>

</style>